module.exports = __webpack_public_path__ + "assets/images/planning.6228f181.png";


//////////////////
// WEBPACK FOOTER
// ./src/reactModules/pages/Person/components/ResourcesBlock/assets/planning.png
// module id = 1680
// module chunks = 0